import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = {
  ...createQueryKeySet<UsePersonListQueryParams>('persons'),
  personDetails: () => ['persons', 'person-detail'] as const,
  personDetail: (id: number) => ['persons', 'person-detail', id] as const,
};

export type UsePersonListQueryParams = Parameters<typeof SSF.api.peopleList>[0];

export function usePersonListQuery(params: UsePersonListQueryParams = {}, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.peopleList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}

export function usePersonQuery(id?: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.peopleRetrieve(id!);
      return data;
    },
    queryKey: keys.detail(id!),
    enabled: !!id,
  });
}

export function usePersonDetailsQuery(id?: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.peopleDetailsRetrieve(id!);
      return data;
    },
    queryKey: keys.personDetail(id!),
    enabled: !!id,
  });
}
